import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTooth,
  faSyringe,
  faBusSimple,
  faTeeth,
  faFaceGrimace,
  faHandHoldingDroplet,
} from "@fortawesome/free-solid-svg-icons";
import ROLES from "./roles";

export enum ChairTypes {
  Dentist = "dentist",
  Surgeon = "surgeon",
  Bus = "bus",
  Hygienist = "hygienist",
  Orthodontist = "orthodontist",
  Sanitar = "sanitar",
}

export interface ChairType {
  label: string;
  icon: JSX.Element;
  requiredRoles?: ROLES[];
}

type IChairTypesList = {
  [key in ChairTypes]: ChairType;
};

export const CHAIR_TYPES: IChairTypesList = {
  [ChairTypes.Dentist]: {
    label: "Zobārsts",
    icon: <FontAwesomeIcon icon={faTooth} />,
    requiredRoles: [ROLES.Doctor],
  },
  [ChairTypes.Surgeon]: {
    label: "Ķirurgs",
    icon: <FontAwesomeIcon icon={faSyringe} />,
    requiredRoles: [ROLES.Doctor],
  },
  [ChairTypes.Bus]: {
    label: "Mobilais autobuss",
    icon: <FontAwesomeIcon icon={faBusSimple} />,
    requiredRoles: [ROLES.Driver],
  },
  [ChairTypes.Hygienist]: {
    label: "Higiēnists",
    icon: <FontAwesomeIcon icon={faTeeth} />,
    requiredRoles: [ROLES.Hygienist],
  },
  [ChairTypes.Orthodontist]: {
    label: "Ortodonts",
    icon: <FontAwesomeIcon icon={faFaceGrimace} />,
    requiredRoles: [ROLES.Orthodontist],
  },
  [ChairTypes.Sanitar]: {
    label: "Sanitārs",
    icon: <FontAwesomeIcon icon={faHandHoldingDroplet} />,
    requiredRoles: [ROLES.Sanitar],
  },
};
